import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class CompanyService {
  static getCompanies(query) {
    return RetailerApiClient.get('companies', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getCompanyByCui(cui) {
    return RetailerApiClient.get('companies/get-company-by-cui?cui=' + cui)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
